import { isBroadcastRelay } from 'calling-cross-tab-library/types/MessageRelayTypes';
import CrossTabConfig from '../calling-cross-tab-utils/CrossTabConfig';
import { logDebugMessage } from '../calling-cross-tab-utils/getCrossTabEmbedDebugger';
import { validatePortMessage } from './validatePortMessage';
import AppDataManager from '../calling-cross-tab-utils/AppDataManager';
import { isRegisterPortConnectionAckMessage } from 'shared-worker-versioning/lib/messages/FromWorkerMessageTypes';
import { isFromWorkerActiveCallConnectionPing, isFromWorkerStandaloneHeartbeat, isFromWorkerUpdatedProviderDetailsMessage, isFromWorkerUpdatedWidgetDetailsMessage } from 'calling-cross-tab-library/messages/FromWorkerMessageTypes';
import { updateProviderDetailsFromWorker, updateWidgetDetailsFromWorker } from '../operators/appDataUpdates';
import WorkerConnection from '../WorkerConnection';
import { createFromWorkerActiveCallConnectionPingResponse, createFromWorkerStandaloneHeartbeatResponse } from 'calling-cross-tab-library/messages/ToWorkerMessages';
import { ConnectionTypes } from 'calling-cross-tab-library/types/ConnectionTypes';
import MessageChannelTypes from 'shared-worker-versioning/lib/constants/MessageChannelTypes';
import ActiveCallManager from './ActiveCallManager';
const handleFromWorkerStandaloneHeartbeatMessage = message => {
  const appData = AppDataManager.getAppData();
  if (appData.widgetDetails.standaloneConnectionId === CrossTabConfig.get().connectionId) {
    WorkerConnection.sendMessage(createFromWorkerStandaloneHeartbeatResponse(message.id));
  }
};
const handleFromWorkerUpdatedWidgetDetailsMessage = message => {
  const {
    result
  } = updateWidgetDetailsFromWorker(AppDataManager.getAppData(), message.payload.widgetDetails);
  if (CrossTabConfig.get().connectionType === ConnectionTypes.STANDALONE_CALLING_APP && !result.widgetDetails.standaloneConnectionId && WorkerConnection.broadcastPollingChannel) {
    WorkerConnection.broadcastPollingChannel.close();
  }
  AppDataManager.setAppData(result);
  ActiveCallManager.maybeUnqueueActiveDataResetOnDisconnect(result.widgetDetails);
};
const handleFromWorkerUpdatedProviderDetailsMessage = message => {
  const {
    result
  } = updateProviderDetailsFromWorker(AppDataManager.getAppData(), message.payload.providerDetails);
  AppDataManager.setAppData(result);
};
const handleBroadCastRelayMessage = message => {
  if (message.destinationConnectionId && message.destinationConnectionId !== CrossTabConfig.get().connectionId) {
    return;
  }
  logDebugMessage(`Received BroadcastRelay Message from Shared Worker ${message.type}`, message);
};
const handleFromWorkerActiveCallConnectionPingMessage = message => {
  WorkerConnection.sendMessage(createFromWorkerActiveCallConnectionPingResponse(message.id));
  ActiveCallManager.queueActiveDataResetOnDisconnect();
};
const handleRegisterPortConnectionAck = message => {
  AppDataManager.setAppData(message.payload);
  WorkerConnection.messageChannelType = message.messageChannel || MessageChannelTypes.PORT_MESSAGES;
};
export function onPollingBroadcastMessage(messageEvent) {
  if (!validatePortMessage(messageEvent)) {
    return;
  }
  const {
    data
  } = messageEvent;
  if (isFromWorkerStandaloneHeartbeat(data)) {
    handleFromWorkerStandaloneHeartbeatMessage(data);
  } else if (isFromWorkerActiveCallConnectionPing(data)) {
    handleFromWorkerActiveCallConnectionPingMessage(data);
  }
}
export function onWorkerMessage(messageEvent, messageChannel) {
  const {
    data
  } = messageEvent;
  if (isRegisterPortConnectionAckMessage(data)) {
    handleRegisterPortConnectionAck(data);
    return;
  } else if (!validatePortMessage(messageEvent)) {
    return;
  }
  if (data && data.type) {
    logDebugMessage(`Received Message from Shared Worker channel ${messageChannel}, ${data.type}`, data);
  }
  if (isFromWorkerUpdatedWidgetDetailsMessage(data)) {
    handleFromWorkerUpdatedWidgetDetailsMessage(data);
  } else if (isFromWorkerUpdatedProviderDetailsMessage(data)) {
    handleFromWorkerUpdatedProviderDetailsMessage(data);
  } else if (isFromWorkerStandaloneHeartbeat(data)) {
    handleFromWorkerStandaloneHeartbeatMessage(data);
  } else if (isFromWorkerActiveCallConnectionPing(data)) {
    handleFromWorkerActiveCallConnectionPingMessage(data);
  } else if (isBroadcastRelay(data)) {
    handleBroadCastRelayMessage(data);
  }
}